import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const ShareProfile = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.post("/me/roots-profile/share", { email: email.trim() }); toast.success(`Sent to ${r.data.sent_to}`); setEmail(""); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={send} className="mt-6 rounded-2xl border border-border bg-card p-5" data-testid="share-profile">
      <div className="font-medium text-navy text-sm">Send your Roots Profile to a teammate or freelancer</div>
      <p className="text-xs text-muted-foreground mt-1">They'll get an email with a link to download the branded PDF. The link works for 30 days.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="their@email.com" data-testid="share-profile-email" className="max-w-xs bg-white" />
        <Button type="submit" disabled={busy || !valid} data-testid="share-profile-send" className="rounded-full bg-navy hover:bg-navy/90 text-white">
          {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />}Send
        </Button>
      </div>
    </form>
  );
};
